/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom"
import AppLayout from "../../../Components/Layout/Layout"
import { useEffect, useState } from "react"
import { converterSituacaoProposta, converterSituacaoProspeccao, IEditarSd43Dto, IProspeccaoSd41Dto, ISd43Dto } from "../../../Dtos/Comercial/Prospeccoes/ProspeccoesDtos"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import ApiService from "../../../Config/ApiConfig"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { Select } from "../../../Components/Select/Select"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import LoadingPage from "../../../Components/Loading/Loading"
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table"
import { ActionButton } from "../../../Components/CardView/CardView"
import { credencialTemAcesso } from "../../../Components/Layout/MenuData"
import { Check, CircleX, Copy, Trash2, View } from "lucide-react"
import { ConfirmeDialog } from "../../../Components/ConfirmeDialog/ConfirmeDialog"
import styled from "styled-components"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { ButtonSecundary } from "../../../Components/Forms/CancelButton/CancelButton"
import { TextArea } from "../../../Components/Forms/TextArea/TextArea"
import { format } from 'date-fns';
import { UltAlt } from "../../../Components/UltAlt/UltAlt"
import axios from 'axios';

interface Endereco {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    ibge: string;
    gia: string;
    ddd: string;
    siafi: string;
}

export const FomrProspeccoesPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })
    const [inEdicao, setInEdicao] = useState<boolean>(false)
    const [formData, setFormData] = useState<ISd43Dto>({} as ISd43Dto)
    const [sd41s, setSd41s] = useState<Array<IProspeccaoSd41Dto>>([])
    const [selectedSd41, setSelectedSd41] = useState<IProspeccaoSd41Dto>()
    const [isModalRepOpen, setIsModalRepOpen] = useState<boolean>(false)
    const [isModalEventOpen, setIsModalEventOpen] = useState<boolean>(false)
    const [descrEvento, setDescrEvento] = useState<string>("")

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Prospecção" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        if (id != null) {
            buscarProspeccaoPeloId()
            buscarRepresentantes()
        } else {
            setInEdicao(true)
        }
    }, [])

    const buscarProspeccaoPeloId = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd43 = await apiService.get<ISd43Dto>("/sd43Controller/buscarProspeccaoPeloId", {
                params: {
                    'sd43id': id
                }
            })

            setFormData(sd43);
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar a licença \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarRepresentantes = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd41 = await apiService.get<Array<IProspeccaoSd41Dto>>("/sd43Controller/buscarRepresentantes")

            setSd41s(sd41);
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar a licença \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeData = (value: string, nome: string) => {
        setFormData(prev => ({
            ...prev,
            [nome]: value
        }));
    }

    const handleExcluirRep = async (sd431id: number) => {
        try {
            if (formData.sd43id == null) return

            setLoading(true)

            const apiService = new ApiService()
            await apiService.delete("/sd43Controller/excluirRepresentante", { params: { sd43id: formData.sd43id, sd431id: sd431id } })

            await buscarProspeccaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao remover representante! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const toggleModalRep = () => {
        setIsModalRepOpen(prev => !prev)
    }
    const toggleModalEvent = () => {
        setIsModalEventOpen(prev => !prev)
    }

    const handleModelCancelar = () => {
        setIsModalRepOpen(false)
        setIsModalEventOpen(false)
    }

    const handleSelectRepresentante = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;

        const reps = sd41s.filter(sd40 => sd40.sd41id === Number(value))
        if (reps == null || reps.length < 1) return;

        setSelectedSd41(reps[0])
    }

    const adicionarRepresentante = async () => {
        try {
            if (id == null) return;
            if (selectedSd41 == null) return;

            setLoading(true)

            const apiService = new ApiService()
            await apiService.post("/sd43Controller/adicionarRepresentante", { sd41id: selectedSd41.sd41id, sd43id: formData.sd43id })

            setIsModalRepOpen(false)
            await buscarProspeccaoPeloId()

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao adicionar Representante! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const adicionarEvento = async () => {
        try {
            if (id == null) return;
            if (descrEvento == null || descrEvento === "") return;

            setLoading(true)

            const apiService = new ApiService()
            await apiService.post("/sd43Controller/adicionarEvento", { descricao: descrEvento, sd43id: formData.sd43id })

            setIsModalEventOpen(false)
            await buscarProspeccaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao adicionar Representante! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleExcluirEvento = async (sd433id: number) => {
        try {
            setLoading(true)

            const apiService = new ApiService()
            await apiService.delete("/sd43Controller/removerEvento", { params: { sd433id: sd433id } })

            await buscarProspeccaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao adicionar Representante! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const btnAdicionarProposta = () => {
        if (id == null) return;
        navigate("/proposta/criar/" + id)
    }

    const handleVisualizarProposta = (sd432id: number) => {
        navigate("/proposta/visualizar/" + sd432id)
    }

    const handleCopiarProposta = (sd432id: number) => {
        navigate(`/proposta/copiar/${id}/${sd432id}`)
    }

    const handleAceitarProposta = async (sd432id: number) => {
        try {
            setLoading(true)

            const apiService = new ApiService()
            await apiService.post("/sd43Controller/aceitarProposta", {}, { params: { sd432id: sd432id } })

            await buscarProspeccaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao Aceitar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleRejeitarProposta = async (sd432id: number) => {
        try {
            setLoading(true)

            const apiService = new ApiService()
            await apiService.post("/sd43Controller/rejeitarProposta", {}, { params: { sd432id: sd432id } })

            await buscarProspeccaoPeloId()
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleBtnCancelar = async () => {
        setInEdicao(false)
        if (id != null) {
            await buscarProspeccaoPeloId();
            return
        }
        navigate("/prospeccoes")
    }

    const handleBtnSalvar = async () => {
        try {
            setLoading(true)

            const editarDto: IEditarSd43Dto = {
                sd43cnpj: formData.sd43cnpj,
                sd43bairro: formData.sd43bairro,
                sd43cep: formData.sd43cep,
                sd43complemento: formData.sd43complemento,
                sd43ddd1: formData.sd43ddd1,
                sd43ddd2: formData.sd43ddd2,
                sd43ddd3: formData.sd43ddd3,
                sd43fone1: formData.sd43fone1,
                sd43fone2: formData.sd43fone2,
                sd43fone3: formData.sd43fone3,
                sd43email: formData.sd43email,
                sd43endereco: formData.sd43endereco,
                sd43forma: formData.sd43forma,
                sd43municipio: formData.sd43municipio,
                sd43na: formData.sd43na,
                sd43nome: formData.sd43nome,
                sd43numero: formData.sd43numero,
                sd43obs: formData.sd43obs,
                sd43princinter: formData.sd43princinter,
                sd43qtdefunc: formData.sd43qtdefunc,
                sd43ramoativ: formData.sd43ramoativ,
                sd43uf: formData.sd43uf,
                sd43id: formData.sd43id
            }


            const apiService = new ApiService()

            if (id != null) {
                await apiService.post("/sd43Controller/editarProspeccao", editarDto)
                await buscarProspeccaoPeloId()

            } else {
                const id = await apiService.post<number>("/sd43Controller/criarProspeccao", editarDto)
                navigate("/prospeccao/" + id)
            }
            setInEdicao(false)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao Salvar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }

    }

    const handleBtnGerarContrato = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()
            await apiService.get("/sd43Controller/cadastrarCliente", { params: { cnpj: formData.sd43cnpj } })
            navigate("/contrato/criar/" + id)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const validarCNPJ = async () => {
        try {
            if (formData.sd43cnpj == null || formData.sd43cnpj === "") return
            setLoading(true)
            const apiService = new ApiService()

            await apiService.get<ISd43Dto>("/sd43Controller/existeProspeccaoComCnpj", {
                params: {
                    'cnpj': formData.sd43cnpj
                }
            })
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `CNPJ invalido! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarCep = async () => {
        try {
            if (formData.sd43cep == null || formData.sd43cep === "") return
            setLoading(true)

            const cep = formData.sd43cep.replace(/\D/g, '');

            if (cep.length !== 8) {
                throw new Error("CEP deve conter 8 dígitos.");
            }

            const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

            if (response.data.erro) {
                throw new Error("CEP não encontrado.");
            }

            const endereco: Endereco = response.data;

            setFormData(prev => ({
                ...prev,
                sd43bairro: endereco.bairro,
                sd43complemento: endereco.complemento,
                sd43endereco: endereco.logradouro,
                sd43municipio: endereco.localidade,
                sd43uf: endereco.uf,
            }))

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `CEP invalido! \n ${error}` })
        } finally {
            setLoading(false)
        }
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }
    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title="Prospecção" />
            <FormContainer>
                <Fieldset legend="Cliente">
                    <Row>
                        <Col md="2">
                            <FormField >
                                <Label>CNPJ <ValidarCnpj onClick={validarCNPJ}>Validar</ValidarCnpj></Label>
                                <Input
                                    type="text"
                                    name="sd43cnpj"
                                    value={formData.sd43cnpj?.toString() ?? ""}
                                    onChange={handleChange}
                                    onBlur={validarCNPJ}
                                    disabled={!inEdicao}
                                    maxCharacters={18}
                                />
                            </FormField>
                        </Col>
                        <Col md="7">
                            <FormField >
                                <Label>Nome</Label>
                                <Input
                                    type="text"
                                    name="sd43nome"
                                    value={formData.sd43nome?.toString() ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    maxCharacters={100}
                                />
                            </FormField>
                        </Col>
                        <Col md="3">
                            <FormField >
                                <Label>Nome Abreviado</Label>
                                <Input
                                    type="text"
                                    name="sd43na"
                                    value={formData.sd43na?.toString() ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                    maxCharacters={20}
                                />
                            </FormField>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="8">
                            <FormField >
                                <Label>Ramo de atividade</Label>
                                <Input
                                    type="text"
                                    name="sd43ramoativ"
                                    value={formData.sd43ramoativ?.toString() ?? ""}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                        <Col md="2">
                            <FormField >
                                <Label>Qtde Funcionários</Label>
                                <Input
                                    type="text"
                                    name="sd43qtdefunc"
                                    value={formData.sd43qtdefunc?.toString() ?? ""}
                                    onChange={handleChange}
                                    validation="numbers"
                                    disabled={!inEdicao}
                                    maxCharacters={4}
                                />
                            </FormField>
                        </Col>
                        <Col md="2">
                            <FormField >
                                <Label>Forma de contato</Label>
                                <Select
                                    name="sd43forma"
                                    onChange={handleChange}
                                    value={formData.sd43forma}
                                    disabled={!inEdicao}
                                >
                                    <option value="" >Selecione a forma...</option>
                                    <option value={0} >Telefone</option>
                                    <option value={1} >E-mail</option>
                                    <option value={2} >Site</option>
                                    <option value={3} >Indicação</option>
                                </Select>
                            </FormField>
                        </Col>
                    </Row>
                </Fieldset>
                <Row style={{ marginTop: "15px" }}>
                    <Col>
                        <Fieldset legend="Situação">
                            <Row>
                                <Col md="2">
                                    <InputData
                                        name="sd43dtatualizacaosituacao"
                                        initialValue={formData.sd43dtatualizacaosituacao}
                                        label="Data"
                                        onChange={(value) => handleChangeData(value, "sd43dtatualizacaosituacao")}
                                        disabled
                                    />
                                </Col>
                                <Col md="10">
                                    <FormField >
                                        <Label>Situação</Label>
                                        <Input
                                            type="text"
                                            name="sd43situacao"
                                            value={converterSituacaoProspeccao(formData.sd43situacao)}
                                            disabled
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                        </Fieldset>
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px", marginBottom: '15px' }}>
                    <Col>
                        <Fieldset legend="Endereço">
                            <Row>
                                <Col md="3">
                                    <FormField >
                                        <Label>CEP</Label>
                                        <Input
                                            type="text"
                                            name="sd43cep"
                                            value={formData.sd43cep}
                                            onChange={handleChange}
                                            validation="numbers"
                                            onBlur={buscarCep}
                                            disabled={!inEdicao}
                                            maxCharacters={8}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="7">
                                    <FormField >
                                        <Label>endereço</Label>
                                        <Input
                                            type="text"
                                            name="sd43endereco"
                                            value={formData.sd43endereco}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={60}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="2">
                                    <FormField >
                                        <Label>número</Label>
                                        <Input
                                            type="text"
                                            name="sd43numero"
                                            value={formData.sd43numero}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={4}
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="5">
                                    <FormField >
                                        <Label>Bairro</Label>
                                        <Input
                                            type="text"
                                            name="sd43bairro"
                                            value={formData.sd43bairro}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={40}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="5">
                                    <FormField >
                                        <Label>Municipio</Label>
                                        <Input
                                            type="text"
                                            name="sd43municipio"
                                            value={formData.sd43municipio}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={30}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="2">
                                    <FormField >
                                        <Label>UF</Label>
                                        <Input
                                            type="text"
                                            name="sd43uf"
                                            value={formData.sd43uf}
                                            onChange={handleChange}
                                            validation="letters"
                                            disabled={!inEdicao}
                                            maxCharacters={2}
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormField >
                                        <Label>Complemento</Label>
                                        <Input
                                            type="text"
                                            name="sd43complemento"
                                            value={formData.sd43complemento}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={30}
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                        </Fieldset>
                    </Col>
                    <Col>
                        <Fieldset legend="Contato">
                            <Row>
                                <Col md="3">
                                    <FormField >
                                        <Label>DDD</Label>
                                        <Input
                                            type="text"
                                            name="sd43ddd1"
                                            value={formData.sd43ddd1}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={2}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="3">
                                    <FormField >
                                        <Label>Telefone</Label>
                                        <Input
                                            type="text"
                                            name="sd43fone1"
                                            value={formData.sd43fone1}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={9}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="3">
                                    <FormField >
                                        <Label>DDD</Label>
                                        <Input
                                            type="text"
                                            name="sd43ddd2"
                                            value={formData.sd43ddd2}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={2}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="3">
                                    <FormField >
                                        <Label>Celular 1</Label>
                                        <Input
                                            type="text"
                                            name="sd43fone2"
                                            value={formData.sd43fone2}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={9}
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="2">
                                    <FormField >
                                        <Label>DDD</Label>
                                        <Input
                                            type="text"
                                            name="sd43ddd3"
                                            value={formData.sd43ddd3}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={2}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="4">
                                    <FormField >
                                        <Label>Celular 2</Label>
                                        <Input
                                            type="text"
                                            name="sd43fone3"
                                            value={formData.sd43fone3}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            validation="numbers"
                                            maxCharacters={9}
                                        />
                                    </FormField>
                                </Col>
                                <Col md="6">
                                    <FormField >
                                        <Label>E-mail</Label>
                                        <Input
                                            type="text"
                                            name="sd43email"
                                            value={formData.sd43email}
                                            onChange={handleChange}
                                            disabled={!inEdicao}
                                            maxCharacters={60}
                                        />
                                    </FormField>
                                </Col>
                            </Row>
                        </Fieldset>
                    </Col>
                </Row>
                <Fieldset legend="Informações Adicionais" >
                    <Row>
                        <Col>
                            <FormField >
                                <Label>Principal interesse pelo sistema</Label>
                                <Input
                                    type="text"
                                    name="sd43princinter"
                                    value={formData.sd43princinter}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                        <Col>
                            <FormField >
                                <Label>Observações</Label>
                                <Input
                                    type="text"
                                    name="sd43obs"
                                    value={formData.sd43obs}
                                    onChange={handleChange}
                                    disabled={!inEdicao}
                                />
                            </FormField>
                        </Col>
                    </Row>
                </Fieldset>

                <Fieldset legend="Representantes" marginTop="15px">
                    {
                        id != null && <ButtonPrimary onClick={() => setIsModalRepOpen(true)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                            Adicionar
                        </ButtonPrimary>
                    }
                    <ScrollableTableContainer>
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>#</Th>
                                        <Th>Código</Th>
                                        <Th>Nome do representante</Th>
                                        <Th>Operações</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.sd431s?.map(sd431 => (
                                        <tr key={sd431.sd431id}>
                                            <Td>{sd431.sd431id}</Td>
                                            <Td>{sd431.sd431rep.sd41codigo}</Td>
                                            <Td>{sd431.sd431rep.sd41nome}</Td>
                                            <Td >
                                                <ConfirmeDialog
                                                    message='Remover representante?'
                                                    onCancel={() => { }}
                                                    onConfirm={() => handleExcluirRep(sd431.sd431id!)}
                                                    trigger={
                                                        <ActionButton className="delete">
                                                            <Trash2 size={16} />
                                                        </ActionButton>
                                                    }
                                                />
                                            </Td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </ScrollableTableContainer>
                </Fieldset>
                <Fieldset legend="Propostas" marginTop="15px">
                    {
                        id != null && <ButtonPrimary onClick={btnAdicionarProposta} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                            Adicionar
                        </ButtonPrimary>
                    }
                    <ScrollableTableContainer>
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>#</Th>
                                        <Th>Código</Th>
                                        <Th>Lic. Uso</Th>
                                        <Th>Mensalidade</Th>
                                        <Th>Situação</Th>
                                        <Th>Operações</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.sd432s?.map(sd432 => (
                                        <tr key={sd432.sd432id}>
                                            <Td>{sd432.sd432id}</Td>
                                            <Td>{sd432.sd432codigo.toString().padStart(3, "0")}</Td>
                                            <Td>{sd432.sd432licencauso?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', })}</Td>
                                            <Td>{sd432.sd432mensalidadecliente?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', })}</Td>
                                            <Td>{converterSituacaoProposta(sd432.sd432situacao)}</Td>
                                            <Td >
                                                <ActionButton title="Visualizar" onClick={() => handleVisualizarProposta(sd432.sd432id!)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                                                    <View size={16} />
                                                </ActionButton>
                                                <ActionButton title="Copiar" onClick={() => handleCopiarProposta(sd432.sd432id!)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                                                    <Copy size={16} />
                                                </ActionButton>
                                                <ActionButton title="Aceitar" onClick={() => handleAceitarProposta(sd432.sd432id!)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                                                    <Check size={16} />
                                                </ActionButton>
                                                <ActionButton title="Recusar" onClick={() => handleRejeitarProposta(sd432.sd432id!)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                                                    <CircleX size={16} />
                                                </ActionButton>
                                            </Td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </ScrollableTableContainer>
                </Fieldset>
                <Fieldset legend="Eventos" marginTop="15px">
                    {
                        id != null && <ButtonPrimary onClick={() => setIsModalEventOpen(true)} disabled={!credencialTemAcesso("prospecção", "sd031edita")}>
                            Adicionar
                        </ButtonPrimary>
                    }
                    <ScrollableTableContainer>
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>#</Th>
                                        <Th>Data</Th>
                                        <Th>Descrição</Th>
                                        <Th>Operações</Th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.sd433s?.map(sd433 => (
                                        <tr key={sd433.sd433id}>
                                            <Td>{sd433.sd433id}</Td>
                                            <Td>{format(sd433.sd433data, 'dd/MM/yyyy')}</Td>
                                            <Td>{sd433.sd433evento}</Td>
                                            <Td >
                                                <ConfirmeDialog
                                                    message='Remover Evento?'
                                                    onCancel={() => { }}
                                                    onConfirm={() => handleExcluirEvento(sd433.sd433id!)}
                                                    trigger={
                                                        <ActionButton className="delete">
                                                            <Trash2 size={16} />
                                                        </ActionButton>
                                                    }
                                                />
                                            </Td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </ScrollableTableContainer>
                </Fieldset>
                <Row style={{ marginTop: "15px" }}>
                    {
                        !inEdicao && <Col md="2">
                            <ButtonPrimary onClick={() => setInEdicao(true)} >
                                Editar
                            </ButtonPrimary>
                        </Col>
                    }
                    {
                        inEdicao && <Col md="4">
                            <ButtonSecundary onClick={handleBtnCancelar} >
                                Cancelar
                            </ButtonSecundary>
                            <ButtonPrimary onClick={handleBtnSalvar} >
                                Salvar
                            </ButtonPrimary>
                        </Col>
                    }
                    {
                        (!inEdicao && formData.sd43situacao === 2) && <Col md="4">
                            <ButtonPrimary onClick={handleBtnGerarContrato} >
                                Gerar Contrato
                            </ButtonPrimary>
                        </Col>
                    }
                </Row>

                <UltAlt>{formData.sd43du}</UltAlt>

                {/* MODAL DE REPRESENTANTE */}
                <Modal isOpen={isModalRepOpen} toggle={toggleModalRep} centered>
                    <ModalHeader toggle={toggleModalRep}>Adicionar representante</ModalHeader>
                    <ModalBody>
                        <Row>
                            <FormField >
                                <Label>Representante</Label>
                                <Select
                                    onChange={handleSelectRepresentante}
                                    disabled={inEdicao}
                                >
                                    <option value={-1} >Selecione um representante...</option>
                                    {
                                        sd41s.map(sd41 => (
                                            <option value={sd41.sd41id} >{sd41.sd41codigo} - {sd41.sd41nome}</option>
                                        ))
                                    }
                                </Select>
                            </FormField>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonSecundary type="button" onClick={handleModelCancelar}>
                            Cancelar
                        </ButtonSecundary>
                        <ButtonPrimary type="button" onClick={adicionarRepresentante}>
                            Adicionar
                        </ButtonPrimary>
                    </ModalFooter>
                </Modal>

                {/* MODAL DE EVENTOS */}
                <Modal isOpen={isModalEventOpen} toggle={toggleModalEvent} centered>
                    <ModalHeader toggle={toggleModalEvent}>Adicionar Evento</ModalHeader>
                    <ModalBody>
                        <Row>
                            <FormField >
                                <Label>Descrição</Label>
                                <TextArea
                                    type="text"
                                    value={descrEvento}
                                    onChange={(e) => setDescrEvento(e.target.value)}
                                />
                            </FormField>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonSecundary type="button" onClick={handleModelCancelar}>
                            Cancelar
                        </ButtonSecundary>
                        <ButtonPrimary type="button" onClick={adicionarEvento}>
                            Adicionar
                        </ButtonPrimary>
                    </ModalFooter>
                </Modal>
            </FormContainer>
        </AppLayout>
    )
}

const ScrollableTableContainer = styled.div`
  height: 200px; // Altura fixa
  overflow-y: auto; // Habilita a barra de rolagem vertical
  border: 1px solid #ccc; // Borda opcional para melhor visualização
  border-radius: 4px; // Borda arredondada
  box-shadow:  ${prop => prop.theme.sombras.padrao};
`;

const ValidarCnpj = styled.span`
    cursor: pointer;
    color: blue
`